import {
  AdminPanelSettings,
  AttachFile,
  BookmarkAdded,
  DashboardTwoTone,
  DateRangeRounded,
  Message,
  Newspaper,
  Report
} from '@mui/icons-material'
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DRAWER_WIDTH } from 'constants/layout'
import { SUPER_ADMIN } from 'constants/permissions'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'
import { hasPermissions } from 'utils/user'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const NivosDrawerFC: React.FC<any> = (props: AppProps) => {
  const { layout, user } = props
  const navigate = useNavigate()

  return (
    <Drawer
      variant={'persistent'}
      anchor={'left'}
      open={layout.drawerIsOpen}
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: 'transparent'
        }
      }}
    >
      <Box
        width={DRAWER_WIDTH}
        height={1}
        display={'flex'}
        flexDirection={'column'}
      >
        <Typography
          align={'center'}
          variant={'h5'}
          paddingTop={2}
          paddingX={4}
          paddingBottom={1}
          borderBottom={2}
          borderColor={'#d4d2d2'}
        >
          MENU
        </Typography>
        <Box flexGrow={1}>
          <List>
            {hasPermissions(user, SUPER_ADMIN) && (
              <ListItem>
                <ListItemButton onClick={() => navigate('/admin')}>
                  <ListItemIcon>
                    <AdminPanelSettings color={'primary'} />
                  </ListItemIcon>
                  <ListItemText primary={layout.language.translations.admin} />
                </ListItemButton>
              </ListItem>
            )}
            <ListItem>
              <ListItemButton onClick={() => navigate('/dashboard')}>
                <ListItemIcon>
                  <DashboardTwoTone color={'primary'} />
                </ListItemIcon>
                <ListItemText primary={'Dashboard'} />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/billboard')}>
                <ListItemIcon>
                  <Newspaper color={'primary'} />
                </ListItemIcon>
                <ListItemText
                  primary={layout.language.translations.billboard}
                />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/calendar')}>
                <ListItemIcon>
                  <DateRangeRounded color={'primary'} />
                </ListItemIcon>
                <ListItemText primary={'Calendar'} />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/amenity-booking')}>
                <ListItemIcon>
                  <BookmarkAdded color={'primary'} />
                </ListItemIcon>
                <ListItemText
                  primary={layout.language.translations.amenityBooking}
                />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/incident-reports')}>
                <ListItemIcon>
                  <Report color={'primary'} />
                </ListItemIcon>
                <ListItemText
                  primary={layout.language.translations.incidentReports}
                />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/documents')}>
                <ListItemIcon>
                  <AttachFile color={'primary'} />
                </ListItemIcon>
                <ListItemText
                  primary={layout.language.translations.documents}
                />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/messages')}>
                <ListItemIcon>
                  <Message color={'primary'} />
                </ListItemIcon>
                <ListItemText primary={layout.language.translations.messages} />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Box>
    </Drawer>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const NivosDrawer = connect(mapStateToProps, mapDispatchToProps)(NivosDrawerFC)

export default NivosDrawer
